const ADMIN_MFA_REMINDER_DISMISSED_KEY = 'ADMIN_MFA_REMINDER_DISMISSED';

function storageKey(username) {
  return username ? `${ADMIN_MFA_REMINDER_DISMISSED_KEY}:${username}` : ADMIN_MFA_REMINDER_DISMISSED_KEY;
}

export function dismissMfaReminderBanner(username) {
  if (!username) {
    return;
  }

  sessionStorage.setItem(storageKey(username), '1');
}

export function clearMfaReminderBannerDismissed(username) {
  if (username) {
    sessionStorage.removeItem(storageKey(username));
    return;
  }

  Object.keys(sessionStorage)
    .filter((key) => key.startsWith(`${ADMIN_MFA_REMINDER_DISMISSED_KEY}:`))
    .forEach((key) => sessionStorage.removeItem(key));
}

export function isMfaReminderBannerDismissed(username) {
  if (!username) {
    return false;
  }

  return sessionStorage.getItem(storageKey(username)) === '1';
}
